"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var EventEmitter = require("eventemitter2");
var invariant = require("invariant");
var errorUtils_1 = require("./errorUtils");
var parser_1 = require("./parser");
var evaluator_1 = require("./evaluator");
var visualizer_1 = require("./visualizer");

var Session = function (_EventEmitter$EventEm) {
    _inherits(Session, _EventEmitter$EventEm);

    function Session(week) {
        _classCallCheck(this, Session);

        var _this = _possibleConstructorReturn(this, (Session.__proto__ || Object.getPrototypeOf(Session)).call(this));

        _this.week = week;
        return _this;
    }

    _createClass(Session, [{
        key: "start",
        value: function start(code) {
            delete this.interpreter;
            delete this.parser;
            delete this.visualizer;
            this.evalCode(code);
            if (this.isInterpreting) {
                this.emit('start');
            }
        }
    }, {
        key: "next",
        value: function next() {
            invariant(this.genInterpreter, 'start() must be called before calling next');
            if (this.isInterpreting) {
                var _genInterpreter$next = this.genInterpreter.next(),
                    nextInterpreter = _genInterpreter$next.value;

                if (!nextInterpreter.errors.isEmpty) {
                    this.isInterpreting = false;
                    var errors = nextInterpreter.errors.map(function (error) {
                        return Object.assign({}, error, { explanation: errorUtils_1.explainError(error) });
                    });
                    this.emit('errors', errors.toJS());
                }
                this.isInterpreting = nextInterpreter.isRunning;
                this.interpreter = nextInterpreter;
                this.visualizer = visualizer_1.next(this.visualizer, this.interpreter);
                if (!this.isInterpreting) {
                    this.emit('done');
                } else {
                    this.emit('next');
                }
            }
        }
    }, {
        key: "untilEnd",
        value: function untilEnd() {
            while (this.isInterpreting) {
                this.next();
            }
        }
    }, {
        key: "addCode",
        value: function addCode(code) {
            invariant(!this.isInterpreting, 'Cannot add more code when previous evaluation is in progress');
            this.evalCode(code);
            this.emit('start');
        }
    }, {
        key: "evalCode",
        value: function evalCode(code) {
            delete this.genInterpreter;
            this.isInterpreting = true;
            this.parser = parser_1.parse(code, this.week, '1.js', this.parser);
            if (this.parser.errors.length > 0) {
                this.isInterpreting = false;
                this.parser.errors.forEach(function (error) {
                    error.explanation = errorUtils_1.explainError(error);
                });
                this.emit('errors', this.parser.errors);
                this.emit('done');
            } else {
                this.visualizer = visualizer_1.create();
                this.interpreter = this.interpreter || evaluator_1.createState();
                this.genInterpreter = evaluator_1.evalProgram(this.parser.node, this.interpreter);
            }
        }
    }]);

    return Session;
}(EventEmitter.EventEmitter2);

exports.Session = Session;
exports.createSession = function (week) {
    return new Session(week);
};
//# sourceMappingURL=server.js.map


//////////////////
// WEBPACK FOOTER
// ../source-toolchain/es5/server.js
// module id = 181
// module chunks = 3